<template>
  <v-dialog v-model="dialog" width="1000px" :fullscreen="$vuetify.display.smAndDown" persistent>
    <v-card> 
      <v-card-title class="redColor d-flex">
        <span class="headline text-white">{{ $t("parts.table.actions") }}</span>
        <v-spacer />

        <!--CLOSE BUTTON-->
        <v-btn variant="outlined" icon large color="white" @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-row>
              <!---------------------------------------ALERT--------------------------------------->
              <v-col cols="12">
                <v-alert
                  v-model="alert.value"
                  type="warning"
                  variant="outlined"
                >
                  <v-row align="center" class="py-1">
                    <v-col cols="12" sm="6">
                      {{ alert.message }}
                    </v-col>
                    <v-col cols="12" sm="6">
                      <!-- Mobile: stacked full-width buttons -->
                      <div class="d-flex d-sm-none flex-column ga-2 mt-2">
                        <v-btn
                          variant="outlined"
                          color="success"
                          block
                          @click="
                            confirm = true;
                            alert.value = false;
                          "
                        >
                          {{ $t("parts.inventory.actions.alert.yes") }}
                        </v-btn>
                        <v-btn
                          variant="outlined"
                          color="error"
                          block
                          @click="
                            confirm = false;
                            alert.value = false;
                          "
                        >
                          {{ $t("parts.inventory.actions.alert.no") }}
                        </v-btn>
                      </div>
                      <!-- Desktop: unchanged inline buttons -->
                      <v-row class="d-none d-sm-flex pt-2">
                        <v-btn
                          variant="outlined"
                          size="small"
                          color="success"
                          class="ma-1"
                          @click="
                            confirm = true;
                            alert.value = false;
                          "
                        >
                          {{ $t("parts.inventory.actions.alert.yes") }}
                        </v-btn>
                        <v-btn
                          variant="outlined"
                          size="small"
                          color="error"
                          class="ma-1"
                          @click="
                            confirm = false;
                            alert.value = false;
                          "
                        >
                          {{ $t("parts.inventory.actions.alert.no") }}
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-alert>
              </v-col>
              <!--------------------------------------BUTTONS-------------------------------------->
              <v-col cols="12" class="pa-0">
                <v-row class="d-flex flex-wrap">
                  <v-col cols="6" sm="2" md="2" lg="3">
                    <v-switch
                      v-model="switchS"
                      :disabled="
                        $store.getters.role === 'User' ||
                        $store.getters.role === 'EbayOperator'
                      "
                      :label="$t('parts.inventory.actions.sell')"
                      color="green"
                    />
                  </v-col>
                  <v-col v-if="part.eBayStatus" cols="6" sm="2" md="2" lg="3">
                    <v-switch
                      v-model="switchE"
                      :disabled="
                        $store.getters.role === 'User' ||
                        $store.getters.role === 'EbayOperator'
                      "
                      :label="$t('parts.inventory.actions.sell') + ' eBay'"
                      color="green"
                    />
                  </v-col>
                  <v-col cols="6" sm="3" md="2" lg="3">
                    <v-switch
                      v-model="switchD"
                      :disabled="parts && parts.length > 1"
                      :label="$t('parts.inventory.actions.damaged')"
                      color="yellow-darken-2"
                    />
                  </v-col>
                  <v-col cols="6" sm="3" md="2" lg="3">
                    <v-switch
                      v-model="switchL"
                      :disabled="parts && parts.length > 1"
                      :label="$t('parts.inventory.actions.lost')"
                      color="orange"
                    />
                  </v-col>
                  <v-col cols="6" sm="2" md="2" lg="3">
                    <v-switch
                      v-model="switchR"
                      :disabled="parts && parts.length > 1"
                      :label="$t('parts.inventory.actions.recycle')"
                      color="red"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <!------------------------------------CLIENTS ROW------------------------------------>
              <v-col
                v-if="
                  switchS &&
                  $store.getters.role !== 'User' &&
                  $store.getters.role !== 'EbayOperator'
                "
                cols="12"
              >
                <v-row>
                  <v-col cols="12" xs="6" sm="8" md="8">
                    <v-autocomplete
                      v-model="client"
                      :items="clients"
                      :label="$t('parts.inventory.actions.select_client')"
                      :rules="rules.requiredSelect"
                      color="red-darken-1"
                      :item-title="clientDisplayTitle"
                      :custom-filter="clientAutocompleteFilter"
                      item-value="_id"
                      prepend-icon="mdi-account"
                      return-object
                      autocomplete="off"
                      clearable
                    />
                  </v-col>
                  <v-col xs="6" sm="4" md="4">
                    <v-btn color="success" class="mt-3 px-2" @click="addClient">
                      {{ $t("parts.inventory.actions.add_client") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <!----------------------------------------------------------------------------------->
              <v-col
                v-if="
                  switchS &&
                  $store.getters.role !== 'User' &&
                  $store.getters.role !== 'EbayOperator'
                "
                cols="12"
              >
                <v-textarea
                  v-model="notes"
                  variant="outlined"
                  label="Notes"
                  color="red-darken-2"
                />
              </v-col>

              <v-col
                v-if="
                  switchS &&
                  $store.getters.role !== 'User' &&
                  $store.getters.role !== 'EbayOperator'
                "
                cols="12"
              >
                <v-row>
                  <!--------------------------------TOTAL PRICE ALL-------------------------------->
                  <v-col v-if="parts && parts.length > 1" cols="4">
                    <v-text-field
                      v-model="partsPrice"
                      disabled
                      :label="$t('parts.inventory.actions.total_price')"
                      color="red-darken-1"
                      type="number"
                      min="0"
                      step="0.01"
                      oninput="validity.valid || (value = '')"
                    />
                  </v-col>
                  <!-------------------------------TOTAL PRICE SINGLE------------------------------>
                  <v-col v-if="!parts || parts.length < 2" cols="4">
                    <v-text-field
                      v-model="part.price"
                      :label="$t('parts.inventory.actions.total_price')"
                      color="red-darken-1"
                      type="number"
                      min="0"
                      step="0.01"
                      oninput="validity.valid || (value = '')"
                    />
                  </v-col>
                  <!-----------------------------CHANGE OR DIFFERENCE------------------------------>
                  <v-col v-if="!parts || parts.length < 2" cols="4">
                    <v-text-field
                      v-if="cash - part.price > 0"
                      v-model="difference"
                      :label="$t('parts.inventory.actions.change')"
                      color="red-darken-1"
                      disabled
                    />
                    <v-text-field
                      v-if="cash - part.price <= 0"
                      v-model="difference"
                      :label="$t('parts.inventory.actions.difference')"
                      color="red-darken-1"
                      disabled
                    />
                  </v-col>
                  <!-------------------------------------CASH-------------------------------------->
                  <v-col v-if="!parts || parts.length < 2" cols="4">
                    <v-text-field
                      v-model="cash"
                      :label="$t('parts.inventory.actions.cash')"
                      color="red-darken-1"
                      type="number"
                      min="0"
                      :max="part.price"
                      step="0.01"
                      oninput="validity.valid || (value = '')"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("parts.inventory.actions.cancel") }}
        </v-btn>
        <v-btn
          v-if="switchS"
          :disabled="
            !valid ||
            (client &&
              typeof client === 'object' &&
              Object.keys(client).length < 1)
          "
          :loading="loading"
          color="green"
          variant="outlined"
          @click="sell"
        >
          {{ $t("parts.inventory.actions.sell") }}
        </v-btn>
        <v-btn
          v-if="switchD"
          :loading="loading"
          :disabled="!confirm"
          color="yellow-darken-2"
          variant="outlined"
          @click="damaged"
        >
          {{ $t("parts.inventory.actions.damaged") }}
        </v-btn>
        <v-btn
          v-if="switchL"
          :loading="loading"
          :disabled="!confirm"
          color="orange"
          variant="outlined"
          @click="lost"
        >
          {{ $t("parts.inventory.actions.lost") }}
        </v-btn>
        <v-btn
          v-if="switchR"
          :loading="loading"
          :disabled="!confirm"
          color="red"
          variant="outlined"
          @click="recycle"
        >
          {{ $t("parts.inventory.actions.recycle") }}
        </v-btn>
        <v-btn
          v-if="switchE"
          :loading="loading"
          :disabled="!confirm"
          color="red"
          variant="outlined"
          @click="sellEbay"
        >
          {{ $t("parts.inventory.actions.sell") }} eBay
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import putRequest from "../../api/putRequest";
import {
  clientAutocompleteFilter,
  clientDisplayTitle,
} from "../../utils/clientDisplay";

export default {
  data: () => ({
    dialog: false,
    valid: false,
    loading: false,
    switchS: true,
    switchD: false,
    switchL: false,
    switchR: false,
    switchE: false,
    alert: {
      value: false,
      message: "",
    },
    confirm: false,
    part: {},
    parts: null,
    partsPrice: null,
    sale: {
      part: {},
      client: {},
    },
    client: {},
    clients: [],
    cash: 0,
    notes: "",
    rules: {
      requiredLetters: [
        (v) => !!v || "Please fill this field",
        (v) => /[A-Za-z]/.test(v) || "Only letters are allowed",
      ],
      requiredNumbers: [
        (v) => !!v || "Please fill this field",
        (v) => /[0-9]/.test(v) || "Only numbers are allowed",
      ],
      requiredSelect: [(v) => (v && !!v.name) || "Item is required"],
    },
    // baseUrl: 'http://localhost:3000',
    baseUrl: "https://api.lekotech.com",
  }),
  computed: {
    difference() {
      if (this.cash - this.part.price >= 0) {
        const difference = (this.cash - this.part.price).toString();
        const trimedNumber = difference.substring(0, 6);
        return trimedNumber;
      }
      const difference = (this.part.price - this.cash).toString();
      const trimedNumber = difference.substring(0, 6);
      return trimedNumber;
    },
  },
  watch: {
    switchS(value) {
      if (value) {
        this.switchD = false;
        this.switchL = false;
        this.switchR = false;
        this.switchE = false;
        this.alert.value = false;
        this.alert.message = "";
      } else if (
        this.switchD === false &&
        this.switchL === false &&
        this.switchR === false &&
        this.switchE === false
      ) {
        this.switchR = true;
      }
    },
    switchE(value) {
      if (value) {
        this.switchD = false;
        this.switchL = false;
        this.switchR = false;
        this.switchS = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.inventory.actions.alert.ebay_message",
        );
      } else if (
        this.switchD === false &&
        this.switchL === false &&
        this.switchR === false &&
        this.switchS === false
      ) {
        this.switchR = true;
      }
    },
    switchD(value) {
      if (value) {
        this.switchS = false;
        this.switchL = false;
        this.switchR = false;
        this.switchE = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.inventory.actions.alert.damaged_message",
        );
      } else if (
        this.switchS === false &&
        this.switchL === false &&
        this.switchR === false &&
        this.switchE === false
      ) {
        this.switchS = true;
      }
    },
    switchL(value) {
      if (value) {
        this.switchS = false;
        this.switchD = false;
        this.switchR = false;
        this.switchE = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.inventory.actions.alert.lost_message",
        );
      } else if (
        this.switchS === false &&
        this.switchD === false &&
        this.switchR === false &&
        this.switchE === false
      ) {
        this.switchS = true;
      }
    },
    switchR(value) {
      if (value) {
        this.switchS = false;
        this.switchD = false;
        this.switchL = false;
        this.switchE = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.inventory.actions.alert.recycled_message",
        );
      } else if (
        this.switchS === false &&
        this.switchD === false &&
        this.switchL === false &&
        this.switchE === false
      ) {
        this.switchS = true;
      }
    },
    client(value) {
      if (value && typeof value === "object" && Object.keys(value).length < 1) {
        this.sale.client_id = value._id;
        this.sale.client.name = value.name;
        this.sale.client.surname = value.surname;
        this.sale.client.email = value.email;
        this.sale.client.phone = value.phone;
      }
    },
  },
  methods: {
    clientDisplayTitle,
    clientAutocompleteFilter,
    open(data) {
      this.getClients();
      this.part = data.part;
      this.cash = data.part.price;
      this.parts = data.parts;
      if (this.parts && this.parts.length > 1) {
        // Calc total price.
        this.partsPrice = this.parts.reduce((acc, val) => {
          // eslint-disable-next-line no-restricted-globals, no-param-reassign
          if (!isNaN(parseInt(val.part.price, 10))) {
            acc += parseInt(val.part.price, 10);
          }
          return acc;
        }, 0);
      }
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.part = {};
      this.parts = null;
      this.partsPrice = null;
      this.sale = {
        part: {},
        client: {},
      };
      this.confirm = false;
      this.alert.value = false;
      this.alert.message = "";
      this.cash = 0;
      this.notes = "";
      this.client = {};
      this.clients = [];
      this.switchS = true;
      this.$emit("close");
    },
    async sell() {
      this.loading = true;
      const promises = [];

      if (this.parts && this.parts.length > 0) {
        const parts = [];
        const tempParts = [];
        this.parts.forEach((p) => {
          if (p.type === "inventory") parts.push(p.part);
          else if (p.type === "temporary") tempParts.push(p.part);
        });
        // Sell inventory parts.
        if (parts.length) {
          parts.forEach((part) => {
            promises.push(
              postRequest.object("/sale/new", {
                price: part.price,
                cash: this.cash,
                notes: this.notes,
                user_id: this.$store.getters.userId,
                client_id: this.client._id,
                part_id: part._id,
              }),
            );
          });
        }
        // Sell temporary parts.
        if (tempParts.length) {
          tempParts.forEach((part) => {
            promises.push(
              putRequest("/temporary-part/insert/sell", "", {
                user_id: this.$store.getters.userId,
                institution_id: this.$store.getters.institutionId,
                part_id: part._id,
                price: part.price,
                currency: "EUR",
                cash: this.cash,
                notes: this.notes,
                client_id: this.client._id,
              }),
            );
          });
        }
      } else {
        // Sell single inventory part.
        promises.push(
          postRequest.object("/sale/new", {
            price: this.part.price,
            cash: this.cash,
            notes: this.notes,
            user_id: this.$store.getters.userId,
            client_id: this.client._id,
            part_id: this.part._id,
          }),
        );
      }

      Promise.all(promises)
        .then((response) => {
          this.loading = false;
          const ebayErrorObject = response[0].data.find(
            (item) => item.ebayError,
          );
          if (
            ebayErrorObject &&
            ebayErrorObject.ebayError &&
            ebayErrorObject.ebayError != null
          ) {
            this.$emit("show-error-modal", ebayErrorObject.ebayError);
          }
          this.close();
        })
        .catch(() => {
          this.loading = false;
          this.close();
        });
    },
    async damaged() {
      this.loading = true;
      putRequest(
        `/part/damaged/${this.part._id}`,
        `user_id=${this.$store.getters.userId}&institution_id=${
          this.$store.getters.institutionId
        }&source=inventory`,
      )
        .then((response) => {
          this.loading = false;
          const ebayErrorObject = response.data.find((item) => item.ebayError);
          if (
            ebayErrorObject &&
            ebayErrorObject.ebayError &&
            ebayErrorObject.ebayError != null
          ) {
            this.$emit("show-error-modal", ebayErrorObject.ebayError);
          }
          this.close();
        })
        .catch((error) => {
          this.loading = false;
          this.close();
        });
    },
    async lost() {
      this.loading = true;
      putRequest(
        `/part/lost/${this.part._id}`,
        `user_id=${this.$store.getters.userId}&institution_id=${
          this.$store.getters.institutionId
        }&source=inventory`,
      )
        .then((response) => {
          this.loading = false;
          const ebayErrorObject = response.data.find((item) => item.ebayError);
          if (
            ebayErrorObject &&
            ebayErrorObject.ebayError &&
            ebayErrorObject.ebayError != null
          ) {
            this.$emit("show-error-modal", ebayErrorObject.ebayError);
          }
          this.close();
        })
        .catch((error) => {
          this.loading = false;
          this.close();
        });
    },
    async recycle() {
      this.loading = true;
      putRequest(
        `/part/recycled/${this.part._id}`,
        `user_id=${this.$store.getters.userId}&institution_id=${
          this.$store.getters.institutionId
        }&source=inventory`,
      )
        .then((response) => {
          this.loading = false;
          const ebayErrorObject = response.data.find((item) => item.ebayError);
          if (
            ebayErrorObject &&
            ebayErrorObject.ebayError &&
            ebayErrorObject.ebayError != null
          ) {
            this.$emit("show-error-modal", ebayErrorObject.ebayError);
          }
          this.close();
        })
        .catch(() => {
          this.loading = false;
          this.close();
        });
    },
    getFirstEbayItemId() {
      const listings = this.part.eBayListings;
      if (!listings || typeof listings !== "object") return null;
      for (const country in listings) {
        if (Array.isArray(listings[country]) && listings[country].length > 0) {
          return listings[country][0]; // return the first item ID found
        }
      }
      return null; // No item found
    },
    async sellEbay() {
      this.loading = true;
      const firstItemId = await this.getFirstEbayItemId();
      postRequest
        .object("/ebay/sell-on-ebay", {
          eBayItemId: firstItemId,
        })
        .then((response) => {
          this.loading = false;
          const ebayErrorObject = response.data.find((item) => item.ebayError);
          if (
            ebayErrorObject &&
            ebayErrorObject.ebayError &&
            ebayErrorObject.ebayError != null
          ) {
            this.$emit("show-error-modal", ebayErrorObject.ebayError);
          }
          this.close();
        })
        .catch(() => {
          this.loading = false;
          this.close();
        });
    },
    searchClient(search) {
      getRequest(
        "/client/search",
        `search=${search}&role=${
          this.$store.getters.role
        }&institution_id=${this.$store.getters.institutionId}`,
      )
        .then(() => {})
        .catch(() => {});
    },
    getClients() {
      getRequest(
        "/client/",
        `role=${this.$store.getters.role}&institution_id=${
          this.$store.getters.institutionId
        }`,
      )
        .then((response) => {
          this.clients = response.clients;
        })
        .catch(() => {});
    },
    addClient() {
      this.$emit("add-client");
    },
    hide() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
    },
  },
};
</script>
